import { styled } from "../../../../../../styles";

export const CustomFieldValue = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  fontFamily: "'Open Sans', sans-serif",
  lineHeight: 1,
});

export const CustomFieldChips = styled("div", {
  display: "inline-flex",
  flexWrap: "wrap",
  gap: "4px",
});
